import type { IntlTelInputInstance } from './types';

const normaliseCountryName = (value: string) =>
	value
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase();

export const syncCountryNames = (
	intlTelInputInstance: IntlTelInputInstance
) => {
	for (const country of intlTelInputInstance.countries) {
		const translatedName =
			intlTelInputInstance.options.i18n[country.iso2] ?? country.name;

		country.name = translatedName;
		country.normalisedName = normaliseCountryName(translatedName);
		country.initials = country.normalisedName
			.split(/[^a-z]/)
			.map((word) => word[0] ?? '')
			.join('');

		const listItem = country.nodeById[intlTelInputInstance.id];
		const countryNameNode =
			listItem?.querySelector<HTMLElement>('.iti__country-name');

		if (countryNameNode) {
			countryNameNode.textContent = translatedName;
		}
	}
};

export const syncIntlTelInputUi = (
	intlTelInputInstance: IntlTelInputInstance
) => {
	intlTelInputInstance.ui.countryList?.setAttribute(
		'aria-label',
		intlTelInputInstance.options.i18n.countryListAriaLabel ?? ''
	);

	if (intlTelInputInstance.ui.searchInput) {
		intlTelInputInstance.ui.searchInput.placeholder =
			intlTelInputInstance.options.i18n.searchPlaceholder ?? '';
		intlTelInputInstance.ui.searchInput.setAttribute(
			'aria-label',
			intlTelInputInstance.options.i18n.searchPlaceholder ?? ''
		);
	}

	intlTelInputInstance.ui.searchClearButton?.setAttribute(
		'aria-label',
		intlTelInputInstance.options.i18n.clearSearchAriaLabel ?? ''
	);

	if (intlTelInputInstance.ui.searchNoResults) {
		intlTelInputInstance.ui.searchNoResults.textContent =
			intlTelInputInstance.options.i18n.zeroSearchResults ?? '';
	}

	intlTelInputInstance.ui.updateSearchResultsA11yText?.();
	intlTelInputInstance._setCountry(
		intlTelInputInstance.getSelectedCountryData().iso2 ?? ''
	);
};
